import Color from 'color';
import { Theme } from '.';

const colors = {
  primary: '#EED351',
  secondary: '#292929',
  success: '#10B981',
  warning: '#F59E0B',
  alert: '#EF4444',
  brand: '#011E41',
  white: '#ffffff',
  black: '#000000',
  grey: '#737373',
  gray: '#737373',
  overlay: 'rgba(0, 0, 0, 0.6)',

  // brand-colors
  yellow: '#EED351',
  graphic: '#292929',
  orange: '#D48625',
  red: '#A9132A',
};

export const colorLevelMap = {
  900: 0.8,
  800: 0.6,
  700: 0.4,
  600: 0.2,
  500: 0,
  400: 0.1,
  300: 0.3,
  200: 0.5,
  100: 0.7,
  50: 0.9,
};
export const greyColorMap = {
  900: '#171717',
  800: '#262626',
  700: '#404040',
  600: '#525252',
  500: '#737373',
  400: '#A3A3A3',
  300: '#D4D4D4',
  200: '#E5E5E5',
  100: '#F5F5F5',
  50: '#FAFAFA',
};

const tint = (c: number, ratio: number) => c + (255 - c) * ratio;

export const getColorFromVar = (
  theme: Theme,
  key: string,
  level: number | undefined = undefined
): string => {
  const originalColor = theme.colors[key];
  if (!originalColor) return '';
  if (!level || level == 500) return originalColor;

  if (key == 'grey' || key == 'gray') {
    return greyColorMap[level];
  }

  const color = Color(originalColor);
  const ratio = colorLevelMap[level];
  if (level > 500) {
    return color.darken(ratio).hex();
  } else {
    let [r, g, b]: number[] = color.rgb().array();
    if (
      typeof r != 'undefined' &&
      typeof g != 'undefined' &&
      typeof b != 'undefined'
    ) {
      return Color.rgb(tint(r, ratio), tint(g, ratio), tint(b, ratio)).hex();
    }
  }

  return originalColor;
};

export default colors;
